import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/app';

if (window.top !== window.self) {
  window.top?.location.assign(window.location.href);
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <Suspense fallback={null}>
      <App />
    </Suspense>,
  );
}
